module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "icon-transmission.db4e057d.png";